'use client';

import { type Exploit, getMultichainExploitResults } from '@revoke.cash/core/exploits';
import type { ChainStatus } from 'components/common/PremiumChainStatusSection';
import { usePremiumAddressPageContext } from '../page-context/PremiumAddressPageContext';

export const usePremiumExploitChecker = (exploits: Exploit[]) => {
  const { chainData } = usePremiumAddressPageContext();

  const eventsByChain = new Map(chainData.map((chain) => [chain.chainId, chain.events]));
  const allowancesByChain = new Map(chainData.map((chain) => [chain.chainId, chain.allowances]));
  const results = getMultichainExploitResults(eventsByChain, allowancesByChain, exploits);

  // Only track chains that appear in the exploit list
  const relevantChainIds = new Set(exploits.flatMap((exploit) => exploit.addresses.map((a) => a.chainId)));

  const chainStatuses: ChainStatus[] = chainData.filter((chain) => relevantChainIds.has(chain.chainId));

  const isLoading = chainStatuses.every((chain) => chain.status === 'loading');

  return { results, chainStatuses, isLoading };
};
